import onboardingEndpoints from 'api/endpoints/onboarding';
import cms from 'api/cms';

export const findOne = (brand) =>
  new Promise(async (resolve, reject) => {
    try {
      const response = await cms({
        method: 'GET',
        url: onboardingEndpoints.onboardingsBrand.replace(':brand', brand),
      });
      resolve(response.data);
    } catch (error) {
      reject(error.message);
    }
  });

export default {
  findOne,
};
